import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getSocialMediaPerformancePosts,
  getSocialMediaPerformanceSummary,
} from '../../../../../ajax';
import {
  FetchSocialMediaPerformancePayload,
  SLICE_NAME,
  SocialMediaPerformancePost,
  SocialMediaPerformanceSummary,
} from './types';

export const fetchSocialMediaPerformanceSummary = createAsyncThunk<
  SocialMediaPerformanceSummary[],
  FetchSocialMediaPerformancePayload
>(`${SLICE_NAME}/fetchSocialMediaPerformanceSummary`, async (payload) => {
  const { campaignId, influencerIds, platform, startTime, endTime } = payload;

  return getSocialMediaPerformanceSummary(
    campaignId,
    influencerIds,
    platform,
    startTime,
    endTime
  );
});

export const fetchSocialMediaPerformancePosts = createAsyncThunk<
  SocialMediaPerformancePost[],
  FetchSocialMediaPerformancePayload
>(`${SLICE_NAME}/fetchSocialMediaPerformancePosts`, async (payload) => {
  const { campaignId, influencerIds, platform, startTime, endTime } = payload;

  return getSocialMediaPerformancePosts(
    campaignId,
    influencerIds,
    platform,
    startTime,
    endTime
  );
});
